import * as React from "react";
import MessengerFlexContainer from "./MessengerFlexContainer";

export default function CloseWindow() {
  return (
    <MessengerFlexContainer>
      <div
        style={{
          textAlign: "center",
          paddingTop: 100,
          height: "100vh",
          background: "#fff"
        }}
      >
        You may now close the window.
      </div>
    </MessengerFlexContainer>
  );
}
